/**
 * The Inertia page components that make up the public, indexable marketing
 * site on the central domain, and therefore the only pages the SSR renderer
 * bundles and renders.
 *
 * Mirrors `App\Support\Seo\MarketingPages::COMPONENTS`. The two lists must
 * agree: the Laravel side decides which responses are dispatched to the SSR
 * server, and this side decides which page modules that server can resolve.
 * `tests/Feature/Central/MarketingSsrTest.php` asserts they match.
 */
export const MARKETING_SSR_PAGES = [
    'Welcome',
    'Pricing',
    'Glossary',
    'help/Index',
    'help/Show',
    'legal/TermsAndConditions',
    'legal/PrivacyPolicy',
] as const;

export type MarketingSsrPage = (typeof MARKETING_SSR_PAGES)[number];

/**
 * Whether an Inertia component name is one of the public marketing pages.
 *
 * Used at boot to decide what a page needs: marketing visitors get no session
 * recording, no surveys and no eager module prefetching, and telemetry is
 * started once the page is idle rather than before first paint.
 */
export const isMarketingPage = (component: string | null | undefined): component is MarketingSsrPage =>
    typeof component === 'string' && (MARKETING_SSR_PAGES as readonly string[]).includes(component);
